import { render, staticRenderFns } from "./bottom-menu.vue?vue&type=template&id=00dc796a&scoped=true&"
import script from "./bottom-menu.vue?vue&type=script&lang=js&"
export * from "./bottom-menu.vue?vue&type=script&lang=js&"
import style0 from "./bottom-menu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bottom-menu.vue?vue&type=style&index=1&id=00dc796a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc796a",
  null
  
)

export default component.exports